// import React from "react";
// import {
//   SummaryPeriod,
//   useFetchOrderSummaryLMFM,
// } from "../../../apis/dashboardApis";

// type ChartItem = {
//   label: string;
//   value: number;
//   color: string;
// };

// const radius = 90;
// const strokeWidth = 28;
// const normalizedRadius = radius - strokeWidth / 2;
// const circumference = normalizedRadius * 2 * Math.PI;

// type OrderStatusChartProps = {
//   summaryType?: SummaryPeriod;
//   startDate?: string;
//   endDate?: string;
// };

// const getTotal = (item?: { total?: number }) => item?.total ?? 0;

// const OrderStatusChart: React.FC<OrderStatusChartProps> = ({
//   summaryType,
//   startDate,
//   endDate,
// }) => {
//   const { data: summaryData } = useFetchOrderSummaryLMFM({
//     type: summaryType ?? "Today",
//     startDate,
//     endDate,
//   });

//   const data: ChartItem[] = [
//     {
//       label: "New",
//       value: getTotal(summaryData?.newOrder),
//       color: "#8B5CF6",
//     },
//     {
//       label: "Collected",
//       value: getTotal(summaryData?.pickupCollected),
//       color: "#F59E0B",
//     },
//     {
//       label: "RIW",
//       value: getTotal(summaryData?.receiveInWarehouse),
//       color: "#14B8A6",
//     },
//     {
//       label: "RFD",
//       value: getTotal(summaryData?.readyForPickup),
//       color: "#06B6D4",
//     },
//     {
//       label: "OFD",
//       value: getTotal(summaryData?.outForDelivery),
//       color: "#3B82F6",
//     },
//     {
//       label: "Delivered",
//       value: getTotal(summaryData?.delivered),
//       color: "#22C55E",
//     },
//     {
//       label: "Not Delivered",
//       value: getTotal(summaryData?.notDelivered),
//       color: "#EF4444",
//     },
//     {
//       label: "Return",
//       value: getTotal(summaryData?.returned),
//       color: "#64748B",
//     },
//   ];

//   const total = data.reduce((acc, item) => acc + item.value, 0);
//   const chartData =
//     total > 0 ? data : [{ label: "No Orders", value: 1, color: "#D2D2D2" }];

//   let cumulativePercent = 0;

//   return (
//     <div className="w-full  rounded-3xl">
//       {/* Header */}
//       <div className="mb-6 flex items-center justify-between">
//         <h2 className="text-lg font-semibold invisible text-[#212121]">
//           Order Status Breakdown
//         </h2>
//       </div>

//       {/* Content */}
//       <div className="flex flex-col items-center justify-center gap-10 md:flex-row">
//         {/* Donut Chart */}
//         <div className="relative flex items-center justify-center">
//           <svg height={radius * 2} width={radius * 2} className="-rotate-90">
//             {chartData.map((item, index) => {
//               const percent = item.value / (total || 1);
//               const strokeDasharray = `${
//                 percent * circumference
//               } ${circumference}`;

//               const strokeDashoffset = -cumulativePercent * circumference;

//               cumulativePercent += percent;

//               return (
//                 <circle
//                   key={index}
//                   stroke={item.color}
//                   fill="transparent"
//                   strokeWidth={strokeWidth}
//                   strokeDasharray={strokeDasharray}
//                   strokeDashoffset={strokeDashoffset}
//                   strokeLinecap="butt"
//                   r={normalizedRadius}
//                   cx={radius}
//                   cy={radius}
//                 />
//               );
//             })}
//           </svg>

//           {/* Center Hole */}
//           <div className="absolute flex h-28 w-28 flex-col items-center justify-center rounded-full bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] text-center">
//             <span className="text-xs text-[#212121]/60">Total</span>
//             <span className="text-2xl font-semibold text-[#212121]">
//               {getTotal(summaryData?.total).toLocaleString()}
//             </span>
//           </div>
//         </div>

//         {/* Legend */}
//         <div className="space-y-4">
//           {data.map((item, index) => (
//             <div key={index} className="flex items-center gap-3">
//               <div
//                 className="h-3 w-3 rounded-full"
//                 style={{ backgroundColor: item.color }}
//               />

//               <span className="min-w-24 text-sm text-[#212121]">
//                 {item.label}
//               </span>
//               <span className="text-sm font-medium text-[#212121]">
//                 {item.value.toLocaleString()}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OrderStatusChart;



/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React from "react";
import {
  SummaryPeriod,
  useFetchOrderSummaryLMFM,
} from "../../../apis/dashboardApis";

type ChartItem = {
  label: string;
  value: number;
  color: string;
};

type OrderStatusChartProps = {
  summaryType?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
};

const radius = 95;
const strokeWidth = 24;
const normalizedRadius = radius - strokeWidth / 2;
const circumference = normalizedRadius * 2 * Math.PI;

const getTotal = (item?: { total?: number }) => item?.total ?? 0;

const OrderStatusChart: React.FC<OrderStatusChartProps> = ({
  summaryType,
  startDate,
  endDate,
}) => {
  const { data: summaryData } = useFetchOrderSummaryLMFM({
    type: summaryType ?? "Today",
    startDate,
    endDate,
  });

  const data: ChartItem[] = [
    {
      label: "New",
      value: getTotal(summaryData?.newOrder),
      color: "#8B5CF6",
    },
    {
      label: "Collected",
      value: getTotal(summaryData?.pickupCollected),
      color: "#F59E0B",
    },
    {
      label: "RIW",
      value: getTotal(summaryData?.receiveInWarehouse),
      color: "#14B8A6",
    },
    {
      label: "RFD",
      value: getTotal(summaryData?.readyForPickup),
      color: "#06B6D4",
    },
    {
      label: "OFD",
      value: getTotal(summaryData?.outForDelivery),
      color: "#3B82F6",
    },
    {
      label: "Delivered",
      value: getTotal(summaryData?.delivered),
      color: "#22C55E",
    },
    {
      label: "Not Delivered",
      value: getTotal(summaryData?.notDelivered),
      color: "#A855F7",
    },
    {
      label: "Return",
      value: getTotal(summaryData?.returned),
      color: "#EF4444",
    },
  ];

  const totalOrders = getTotal(summaryData?.total);

  const others =
    totalOrders -
    data.reduce((acc, item) => acc + item.value, 0);

  const finalData: ChartItem[] = [
    ...data,
    {
      label: "Others",
      value: others > 0 ? others : 0,
      color: "#9CA3AF",
    },
  ];

  const chartData =
    totalOrders > 0
      ? finalData.filter((item) => item.value > 0)
      : [{ label: "No Orders", value: 1, color: "#D1D5DB" }];

  let cumulativePercent = 0;

  return (
    <div className="w-full h-full flex flex-col">
      {/* Header */}
      <div className="flex items-center gap-2 mb-8">
        <div className="w-8 h-8 rounded-lg bg-[#F3E8FF] flex items-center justify-center">
          <img
            src="/img/bar-chart.png"
            alt="chart"
            className="w-4 h-4"
          />
        </div>

        <h2 className="text-xl font-semibold text-[#1F2937]">
          Order Distribution
        </h2>
      </div>

      {/* Content */}
      <div className="flex flex-col items-center flex-1">
        {/* Donut Chart */}
        <div className="relative flex items-center justify-center mb-10">
          <svg
            height={radius * 2}
            width={radius * 2}
            className="-rotate-90"
          >
            {/* Background Ring */}
            <circle
              stroke="#F3F4F6"
              fill="transparent"
              strokeWidth={strokeWidth}
              r={normalizedRadius}
              cx={radius}
              cy={radius}
            />

            {chartData.map((item, index) => {
              const percent = item.value / (totalOrders || 1);

              const strokeDasharray = `${
                percent * circumference
              } ${circumference}`;

              const strokeDashoffset =
                -cumulativePercent * circumference;

              cumulativePercent += percent;

              return (
                <circle
                  key={index}
                  stroke={item.color}
                  fill="transparent"
                  strokeWidth={strokeWidth}
                  strokeDasharray={strokeDasharray}
                  strokeDashoffset={strokeDashoffset}
                  strokeLinecap="round"
                  r={normalizedRadius}
                  cx={radius}
                  cy={radius}
                />
              );
            })}
          </svg>

          {/* Center */}
          <div className="absolute flex h-36 w-36 flex-col items-center justify-center rounded-full bg-white shadow-inner border border-[#F3F4F6]">
            <span className="text-sm text-[#6B7280] mb-1">
              Total
            </span>

            <span className="text-5xl font-bold text-[#111827]">
              {totalOrders}
            </span>
          </div>
        </div>

        {/* Legend */}
        <div className="w-full grid grid-cols-2  gap-4">
          {finalData.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between"
            >
              <div className="flex items-center gap-3">
                <div
                  className="w-3 h-3 rounded-full"
                  style={{
                    backgroundColor: item.color,
                  }}
                />

                <span className="text-[15px] text-[#4B5563] font-medium">
                  {item.label}
                </span>
              </div>

              <span className="text-[15px] font-semibold text-[#111827]">
                {item.value}
              </span>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-8 w-full rounded-2xl bg-[#F9FAFB] border border-[#F3F4F6] px-4 py-3 flex items-center justify-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-[#6B7280]"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>

          <span className="text-sm text-[#6B7280]">
            Last updated:
          </span>

          <span className="text-sm font-medium text-[#374151]">
            {new Date().toLocaleDateString()} •{" "}
            {new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default OrderStatusChart;